module.exports = __webpack_public_path__ + "img/8.dcd432e4.png";